<template>
    <footer class="footer-page">
      <b-row>
        <b-col order="5" order-sm="5" order-md="1" order-lg="1" order-xl="1" cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="content-logo">
            <!-- <b-img :src="require('../assets/img/LogoPrincipal.svg')" fluid alt="Fluid image"></b-img> -->
            <router-link :to="{path: '/'}"><b-img :src="require('../assets/img/LogoPrincipal.svg')" fluid alt="Fluid image"></b-img></router-link>
          </div>
        </b-col>
        <b-col order="1" order-sm="1" order-md="2" order-lg="2" order-xl="2" cols="12" sm="12" md="4"  lg="4" xl="3">
          <div class="footer-data">
            <span>{{ $t("footer.visit") }}</span>
            <p class="maps">
              {{ $t("footer.visit_head") }} 
              <br><br>
              <a class="footer_hover footer_direction" href="https://www.google.com.mx/maps/place/WeWork+Centtral+Interlomas/@19.3927744,-99.282897,17z/data=!3m1!4b1!4m12!1m6!3m5!1s0x85d207ab854ce0d5:0x55c364b284251515!2sWeWork+Centtral+Interlomas!8m2!3d19.3927694!4d-99.2807083!3m4!1s0x85d207ab854ce0d5:0x55c364b284251515!8m2!3d19.3927694!4d-99.2807083" target="_blank">
                {{ $t("footer.visit_content") }}
              </a>
            </p>
          </div>
        </b-col>
        <b-col order="2" order-sm="2" order-md="3" order-lg="3" order-xl="3" cols="12" sm="12" md="4" lg="4" xl="3">
          <div class="footer-data">
            <span>{{ $t("footer.quotation") }}</span>
            <p class="contact-styles">
              <a href="tel:5540397847" target="_blank" class="footer_hover">+55 4039 7847</a> 
              <br>
              <a href="mailto:hello@marabunta.work" class="footer_hover">hello@marabunta.work</a>
            </p>
          </div>
        </b-col>
        <b-col order="3" order-sm="3" order-md="4" order-lg="4" order-xl="4" cols="12" sm="12" md="12" lg="12" xl="2">
          <div class="footer-data">
            <span>{{ $t("footer.follow") }}</span>
            <div class="icons">
              <a class="footer_hover icon_ins" href="https://www.instagram.com/marabunta.mx/?hl=es-la" target="_blank"><icon-base box="0 0 39 39" width="40" height="40" icon-name="Instagram"><icon-instagram /></icon-base></a>
              <a class="footer_hover" href="https://www.facebook.com/MxMarabunta" target="_blank"><icon-base icon-name="Facebook"><icon-facebook /></icon-base></a>
              <a class="footer_hover" href="https://twitter.com/Marabunta_MX" target="_blank"><icon-base icon-name="Twitter"><icon-twitter /></icon-base></a>
            </div>
          </div>

        </b-col>
        <b-col cols="12" order="4" order-sm="4" order-md="5" order-lg="5" order-xl="5">
          <div class="content-copyright">
            <b-row align-v="end">
              <b-col cols="6" class="styles-copyright-1">
                <span>{{ $t("footer.copyright") }}</span>
                <br>
                <span class="footer_hover" onclick="window.open('https://temporal.marabunta.work/docs/Aviso_de_Privacidad.pdf','_blank')" style="cursor: pointer;">{{ $t("footer.privacy_notice") }}</span>
              </b-col>
              <b-col class="align-mar" cols="6">
                <router-link :to="{path: '/marbymarabunta#home-mar'}" tag="button" class="btn-mar"><icon-base box="0 0 32 32" width="30" height="30" icon-name="Mar"><icon-mar /></icon-base> {{ $t("footer.button_mar") }}</router-link>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col order="6" order-sm="6" order-md="6" order-lg="6" order-xl="6" cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="content-copyright styles-copyright-2">
            <span>{{ $t("footer.copyright") }}</span>
            <br>
            <span class="footer_hover" onclick="window.open('https://marabunta.work/docs/Aviso_de_Privacidad.pdf','_blank')" style="cursor: pointer;">{{ $t("footer.privacy_notice") }}</span>
          </div>
        </b-col>
      </b-row>
    </footer>
</template>

<style>
.btn-mar{
  font-family: "Gotham Medium Regular";
  font-size: 18px;
  color: #FFF;
  background: transparent;
  text-decoration: none;
  border: 3px solid #FFF;
  border-radius: 0%;
  margin-top: 0px;
  width: 350px;
  height: 60px;

  background-size: 200% 100% !important;
  background-image: linear-gradient(to right, transparent 50%, #fff 50%) !important;
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
  transition: background-position 1s;
}
.btn-mar:hover{
  background-position: -100% 0 !important;
  color:#04182E !important;
}
.btn-mar:hover svg path{
  stroke: #04182E;  
  fill: #04182E;
}
.btn-mar svg{
  margin-bottom: -8px;
  margin-right: 5px;
}
.styles-copyright-1 br{
  display: none;
}

.styles-copyright-2{
  display: none;
}

.footer_direction{
  white-space: pre-line;
}

.footer-page{
  background-color: #04182E;
  color: #FFFFFF;
  padding: 100px 50px 40px 50px;
  bottom: 0px !important;
}
.content-logo img{
  width: 50%;
}
.align-mar{
  text-align: right;
}
.content-copyright{
  margin-top: 30px;
  white-space: nowrap;
}
 .content-copyright span:first-child{
  font-family: "Gotham light Regular";
  font-size: 16px;
  margin-right: 20px;
  letter-spacing: 0px;
  /* line-height: 21px; */
}
.content-copyright span:last-child{
  font-family: "Gotham Medium Regular";
  font-size: 20px;
  letter-spacing: 0px;
  line-height: 28px;
}
.footer-data{
  text-align: right;
}
.footer-data span{
  /* font-family: "Gotham Bold Regular"; */
  font-family: "Gotham Medium Regular";
  font-size: 20px;
  letter-spacing: 1.54px;
  line-height: 23px;
}
.footer-data p{
  font-family: "Gotham Book Regular";
  font-size: 20px;
  margin-top: 20px;
  letter-spacing: 0px;
  line-height: 21px;
}

.contact-styles a[href^="tel:"], .contact-styles a[href^="mailto:"]{
  color: #FFF;
  text-decoration: none;
}

.maps a[href]{
  color: #FFF;
  text-decoration: none;
}

.icons{
  margin-top: 20px;
}

.icons svg{
  cursor: pointer;
  margin-left: 16px;
  width: 27px;
  height: 27px;
}

.footer_hover:hover{
  color: #2abecc !important;
}

.icons .icon_ins:hover svg path{
  stroke: #2abecc !important;
}

.icons a:link, .icons a:visited, .icons a:hover, .icons a:active{
  color: #FFF;
}

@media (max-width: 1800px){
  .content-copyright span:first-child{
    font-size: 16px;
    line-height: 18px;
  }
  .content-copyright span:last-child{
    font-size: 16px;
    line-height: 22px;
  }
  .footer-data span{
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 22px;
  }
  .footer-data p{
    font-size: 16px;
    line-height: 18px;
  }
}

@media (max-width: 1600px){
  .btn-mar{
    font-size: 14px;
    width: 280px;  
    height: 45px;
  }
  .btn-mar svg{
    margin-bottom: -9px;
    transform: scale(0.65);
  }
}

@media (max-width: 1200px){
  .content-logo img{
    width: 70%;
  }
}

@media (max-width: 960px){
  .content-logo img{
    width: 80%;
  }
  .content-copyright span:first-child{
    font-size: 14px;
    line-height: 15px;
  }
  .content-copyright span:last-child{
    font-size: 14px;
    line-height: 20px;
  }
  .footer-data span{
    font-size: 15px;
    letter-spacing: 1.16px;
    line-height: 21px;
  }
  .footer-data p{
    font-size: 14px;
    line-height: 15px;
  }
  .styles-copyright-1 br{
    display: block;
  }
}

@media (max-width: 767px){
  .styles-copyright-1{
    display: none;
  }
  .align-mar{
    text-align: left;
    margin-top: 20px;
  }
  .content-logo img{
    width: 50%;
  }
  .content-logo{
    margin: 60px 0px;
    text-align: center;
  }
  .content-copyright{
    margin-top: 0;
    white-space: normal;
  }
  .footer-data{
    text-align: left;
  }
  .styles-copyright-2{
    display: block;
  }
  .footer_direction{
    white-space: normal;
  }
  .footer-data p{
    line-height: 20px;
  }
  .icons .icon_ins svg{
    margin-left: 0;
  }
}

@media (max-width: 575px) {
  .footer-page{
    padding: 100px 7% 40px 7%;
  }
}

</style>
<script>
import IconBase from './IconBase'
import IconFacebook from './icons/IconFacebook'
import IconInstagram from './icons/IconInstagram'
import IconTwitter from './icons/IconTwitter'
import IconMar from './icons/IconMar'

export default {
  name: 'FooterComponent',
  components: {
    IconBase,
    IconFacebook,
    IconInstagram,
    IconTwitter,
    IconMar
  }
}
</script>